import { z } from 'zod';
import { Api } from '@automapa/svelte-automapa-template';

export const CollectionRequestSchema = z.object({
    name: z.string().catch(''),
    column_match: z.any().nullable(),
});
export type CollectionRequestType = z.infer<typeof CollectionRequestSchema>;

export const CollectionResponseSchema = CollectionRequestSchema.merge(
    z.object({
        id: z.number(),
        revision: z.string().catch(''),
        updated: z.string().catch(''),
        created: z.string().catch(''),
    })
);
export type CollectionResponseType = z.infer<typeof CollectionResponseSchema>;

export class CollectionApi {
    public static async getCollection(api: Api) {
        return api.getData<any, CollectionResponseType>(
            'post',
            '/collection/get_customer_collection',
            {},
            z.object({}),
            CollectionResponseSchema
        );
    }
}
